<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import lodash from 'lodash';
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowActivePatientsSubtotal',
    extends: TableRowBase,
    data() {
      return {
        fields: [
          'total_active_patients_scit',
          'total_active_patients_scit',
          'total_active_patients_unknown',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.curMonth[field])
        }, 0);
      },
      benchmarkYtdRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.benchmarkMonth[field])
        }, 0);
      },
    },
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(yearObj[throughMonth - 1][field]);
        }, 0);
      },
    },
  };
</script>
